<section class="detail-card">
  <h4>Event Skills (Dynamic)</h4>
  <div class="event-skills-grid">
    <div
      class="detail-field"
      *ngFor="let displaySkill of displayEventSkills; trackBy: trackByLabel"
    >
      <label>{{ displaySkill.label }}</label>
      <select
        class="form-control state-native-select"
        [ngClass]="getEventSkillClass(displaySkill)"
        [ngModel]="getEventSkillValue(displaySkill)"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="readOnly"
        (ngModelChange)="onEventSkillChanged(displaySkill, $event)"
      >
        <option
          *ngIf="isInconsistent(displaySkill)"
          [value]="inconsistentSkillValue"
          disabled
        >
          INCONSISTENT
        </option>
        <option
          *ngFor="let option of config.eventSkillOptions"
          [value]="option"
        >
          {{ option }}
        </option>
      </select>
    </div>
  </div>
</section>
